import { FormEvent, useState } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { registerUser } from '../lib/api';
import { errorMessage, guestCheckInPathFromReturnTo, isMtibEmail, isValidEmail, normalizeEmail, normalizeProfileText } from '../lib/utils';
import { useAppSession } from '../context/AppSessionContext';
import { useToast } from '../context/ToastContext';

export default function RegisterPage() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(() => normalizeEmail(params.get('email') ?? ''));
  const returnTo = guestCheckInPathFromReturnTo(params.get('returnTo'));
  const internal = isMtibEmail(email);
  const [name, setName] = useState('');
  const [org, setOrg] = useState('');
  const [busy, setBusy] = useState(false);
  const { setProfile } = useAppSession();
  const { showToast } = useToast();
  const navigate = useNavigate();

  if (!returnTo) return <Navigate to="/" replace />;
  if (internal) return <Navigate to={`/staff-auth?returnTo=${encodeURIComponent(returnTo)}`} replace />;

  const backToEmail = () => {
    navigate(returnTo, { replace: true });
  };

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!isValidEmail(email) || name.trim().length < 2 || org.trim().length < 2) {
      showToast('Masukkan e-mel, nama dan organisasi yang sah.', 'error');
      return;
    }
    setBusy(true);
    try {
      const normalizedEmail = normalizeEmail(email);
      await registerUser({ email: normalizedEmail, fullName: normalizeProfileText(name), departmentOrg: normalizeProfileText(org) });
      setProfile({
        email: normalizedEmail,
        fullName: normalizeProfileText(name),
        departmentOrg: normalizeProfileText(org),
      });
      showToast('Profil berjaya didaftarkan.', 'success');
      navigate(returnTo, { replace: true });
    } catch (error) {
      showToast(errorMessage(error), 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-card auth-card-wide">
        <div className="eyebrow">Pendaftaran kali pertama</div>
        <h1>Profil Tetamu</h1>
        <p className="muted">Cipta profil tetamu untuk meneruskan <em>check-in</em>. Profil tetamu tidak mempunyai halaman Utama.</p>
        <form onSubmit={submit} className="form-stack">
          <label className="field">
            <span>E-mel</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
          </label>
          <label className="field">
            <span>Nama penuh</span>
            <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" required maxLength={120} />
          </label>
          <label className="field">
            <span>Nama syarikat / organisasi</span>
            <input value={org} onChange={(e) => setOrg(e.target.value)} required maxLength={160} />
          </label>
          <button className="button button-primary button-block" disabled={busy}>{busy ? 'Sedang menyimpan…' : 'Simpan profil dan teruskan'}</button>
          <button type="button" className="button button-secondary button-block" onClick={backToEmail} disabled={busy}>Gunakan e-mel lain</button>
        </form>
      </section>
    </main>
  );
}
